import { useMemo } from "react";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import { useSiteContext } from "../components/Site";

const useCarouselLabels = () => {
  const { getMicroCopy } = useSiteContext();

  const previousSlideLabel = useMemo(() => {
    const cmsLabel = getMicroCopy(microCopy.CAROUSEL_PREVIOUS_SLIDE_LABEL);

    return cmsLabel.startsWith("MC:") ? "Previous slide" : cmsLabel;
  }, [getMicroCopy]);

  const nextSlideLabel = useMemo(() => {
    const cmsLabel = getMicroCopy(microCopy.CAROUSEL_NEXT_SLIDE_LABEL);

    return cmsLabel.startsWith("MC:") ? "Next slide" : cmsLabel;
  }, [getMicroCopy]);

  return { previousSlideLabel, nextSlideLabel };
};

export default useCarouselLabels;
